import React, { useEffect, useRef, useState } from 'react'
import { Image, Text, View, TouchableOpacity, Pressable } from 'react-native'
import { fetchAuthSession } from 'aws-amplify/auth'
import {
    FormContentsModel,
    FormsModel,
    ModelAnswerFromProps,
    SecondaryActionsModel,
} from '../models/StoreDetailModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../../theme'
import { MultipleSelectList, SelectList } from 'react-native-dropdown-select-list'
import styles from './DropdownItemStyles'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { FORM_SCHEDULE_STATUS } from '../constants/constants.stores'
import ScheduleServices from '../../../../database-sqlite/services/scheduleServices'
import { CustomCheckBox } from '../../customUtils/Components/CustomCheckBox'
import MultiSelect from 'react-native-multiple-select'
import Icon from 'react-native-vector-icons/MaterialIcons'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { PATH_ASSETS } from '../../../utils/Constants'
import useImageLoader from '../../../hooks/useImageLoader'
import { Loader } from '../../customUtils/Components/Loader'
import { request_get_users_dropdown } from '../../../services/schedule.services'
import { validateConnectionNetwork } from '../../../utils/functions.utils'
import { getAlert } from '../../appBar/context/AlertsContext'

interface DropdownItemProps {
    item: FormContentsModel
    hideOrShow: (
        hides?: string[],
        show?: string[],
        data?: FormContentsModel[],
    ) => void
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    data: FormContentsModel[]
}

export const DropdownItem = React.memo(
    ({
        item,
        hideOrShow,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
        data,
    }: DropdownItemProps) => {
        const [selectedValue, setSelectedValue] = useState<SecondaryActionsModel>()
        const [options, setOptions] = useState<
            Array<{ key: string; value: string }>
        >([])
        const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)
        const [defaultOption, setdefaultOption] = useState(null)
        const [enableButtonRefresh, setEnableButtonRefresh] = useState(false)
        const [loaderUsersDropdown, setLoaderUsersDropdown] = useState(false)
        const { image, loading, placeholderGeneral } = useImageLoader(
            item.media,
            PATH_ASSETS,
        )
        const { setAlert } = getAlert()
        const [preview, setPreview] = useState(image)
        useEffect(() => {
            setPreview(image)
        }, [image])
        useEffect(() => {
            if (item?.old_response) {
                const option_selected_id = item.old_response.option_selected_id[0]
                // console.log("33 -- 🚀 ~ file: DropdownItem.tsx:33 ~ useEffect ~ option_selected_id:", option_selected_id)

                const findIndex = item.secondary_actions.findIndex(
                    (action) => action._id === option_selected_id,
                )
                // console.log("36 ---🚀 ~ file: DropdownItem.tsx:36 ~ useEffect ~ findIndex:", findIndex)

                if (findIndex !== -1) {
                    const defaultItem = {
                        key: item.secondary_actions[findIndex]._id,
                        value: item.secondary_actions[findIndex].label,
                    }

                    //console.log('44 --- defaultItem: ', defaultItem)

                    //sconsole.log('46 ---- item.secondary_actions[findIndex]: ', item.secondary_actions[findIndex])
                    setSelectedValue(item.secondary_actions[findIndex])
                    setdefaultOption(defaultItem)
                }

                if (
                    item.secondary_actions[findIndex] &&
                    item.secondary_actions[findIndex].hide_questions &&
                    item.secondary_actions[findIndex].show_questions
                ) {
                    // console.log('Muestra')
                    // console.log('Muestra')
                    hideOrShow(
                        item.secondary_actions[findIndex].hide_questions,
                        item.secondary_actions[findIndex].show_questions,
                        data,
                    )
                }
            }
        }, [item?.old_response])

        useEffect(() => {
            // console.log("LLAMO")
            if (item.secondary_actions && item.secondary_actions.length > 0) {
                const mappedOptions = item.secondary_actions.map((option) => ({
                    key: option._id,
                    value: option.label,
                    disabled:
                        (option.status != null && option.status) === -1
                            ? true
                            : false,
                }))

                setOptions(mappedOptions)
            } else {
                const not_user = {
                    key: '0',
                    value: 'No tienes usuarios para relevar',
                }
                setdefaultOption(not_user)
                setOptions([not_user])
                setEnableButtonRefresh(true)
            }
        }, [])

        const onSelectOption = async (optionValue: string) => {
            try {
                const selectedOption = item.secondary_actions.find(
                    (option) => option.label === optionValue,
                )
                //console.log('🔴 10 -----onSelectOption ~ selectedOption:', selectedOption)
                if (!selectedOption || selectedOption == selectedValue) {
                    // console.log('🔴 111 ----- Selected option is undefined')
                    return
                }

                // ✅ Eliminar respuestas de preguntas que se van a ocultar ANTES de todo
                await deleteOldResponse(
                    item._id,
                    selectedOption,
                    schedule_id,
                    form_id,
                    store_id,
                )

                const answer: ModelAnswerFromProps = {
                    _id: item._id,
                    option_selected_text: [selectedOption.label],
                    option_selected_id: [selectedOption._id],
                    question_id: item._id,
                    media: '',
                    question_text: item.title,
                    score: selectedOption.score
                        ? selectedOption.score.toString()
                        : '0',
                    status: 1,
                    date_finish: new Date().toString(),
                    date_init: new Date().toString(),
                    question_input: '',
                    field_media: '',
                    field_text: '',
                    questionScore: item.questionScore,
                    type: item.input_type.type,
                    ponderar: item.questionScore && item.questionScore > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                    question: item.title,
                    questionOptionSelected: [selectedOption._id],
                    questionOptionSelectedText: [selectedOption.label],
                    questionType: {
                        title: item.input_type.title,
                        type: item.input_type.type,
                        id: item.input_type._id,
                    },
                    questionPrice: '',
                    description: '',
                    tag: '',
                    questionImage: '',
                    questionInput: '',
                }

                // console.log(JSON.stringify(selectedOption.hide_questions) , " - " , JSON.stringify(selectedOption.show_questions))
                if (selectedOption.hide_questions && selectedOption.show_questions) {
                    hideOrShow(
                        selectedOption.hide_questions,
                        selectedOption.show_questions,
                        data,
                    )
                }

                setSelectedValue(selectedOption)

                // console.log('Set data')
                await updateFormAnswerSchedule({
                    newAnswer: answer,
                    schedule_id,
                    form_id,
                    store_id,
                })

                await checkComplete(answer)
            } catch (error) {
                console.error(error)
            }
        }

        const deleteOldResponse = async (
            questionId: string,
            selectedOption: SecondaryActionsModel,
            schedule_id: string,
            form_id: string,
            store_id: string,
        ) => {
            try {
                if (
                    selectedOption &&
                    selectedOption.hide_questions &&
                    selectedOption.hide_questions.length > 0
                ) {
                    // ✅ Eliminar respuestas de las preguntas que se van a ocultar
                    console.log(
                        '🗑️ Eliminando respuestas de preguntas ocultas:',
                        selectedOption.hide_questions,
                    )
                    await ScheduleServices.removeKeyOldResponseFormAnswerSchedule(
                        schedule_id,
                        form_id,
                        store_id,
                        selectedOption.hide_questions,
                    )
                }
            } catch (error) {
                console.error('❌ deleteOldResponse -- ERROR: ', error)
            }
        }
        const deleteValueDropdown = (
            arraySecondaryActions: SecondaryActionsModel[],
        ) => {
            const arrayIdQuestions = arraySecondaryActions
                .map((secon) => {
                    if (secon.show_questions) {
                        return secon.show_questions
                    }
                })
                .flat()

            // tengo los ids de las questios a las que debo setear por default
            console.log('241 --- arrayIdQuestions: ', arrayIdQuestions)
        }

        const toggleDropdown = () => {
            setIsDropdownOpen(!isDropdownOpen)
        }
        const { openBottomSheet, closeBottomSheet } = useBottomSheet()

        const openBigImage = () => {
            if (image) {
                openBottomSheet(
                    <ImageWithZoom uri={image} contentSeen={() => {}} path={''} />,
                    undefined,
                    undefined,
                    true,
                    true,
                    true,
                )
            }
        }

        const onRefreshUsers = async () => {
            try {
                setLoaderUsersDropdown(true)
                const hasConnection = await validateConnectionNetwork()

                if (!hasConnection) {
                    console.error('No internet connection')
                    setAlert(
                        'No tienes conexión',
                        'white',
                        'wifi-off',
                        'rgba(229, 29, 13, 0.8)',
                    )
                    return
                }
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''

                const paramsRequest = {
                    authToken,
                    form_id,
                    schedule_id,
                    store_id,
                    question_id: item._id,
                }
                const data = await request_get_users_dropdown(paramsRequest)

                const users = data.response.single.data

                if (!users || users.length == 0) {
                    console.error('No users')
                    return
                }

                const mappedOptions = users.map((option) => ({
                    key: option._id,
                    value: option.label,
                }))

                setOptions(mappedOptions)
                setEnableButtonRefresh(false)
            } catch (error) {
                console.error('229 --- onRefreshUsers ~ error: ', error)
            } finally {
                setLoaderUsersDropdown(false)
            }
        }

        return (
            <View>
                {item.media && (
                    <TouchableOpacity onPress={() => openBigImage()}>
                        {loading ? (
                            <Loader />
                        ) : (
                            <Image
                                style={styles.image}
                                source={{ uri: preview }}
                                onError={(e) => {
                                    setPreview(placeholderGeneral)
                                }}
                            />
                        )}
                    </TouchableOpacity>
                )}

                <Text style={styles.title}>{item.title}</Text>

                {options.length > 2 ? (
                    <SelectList
                        placeholder='Selecciona una opción'
                        maxHeight={10000}
                        data={options}
                        save='value'
                        search={false}
                        searchPlaceholder='Buscar...'
                        arrowicon={
                            <Feather
                                name={'chevron-down'}
                                size={22}
                                color={theme.colors.colorPrimary}
                            />
                        }
                        boxStyles={
                            !isDropdownOpen ? styles.inputWithMargin : styles.input
                        }
                        dropdownStyles={styles.dropdown}
                        dropdownTextStyles={styles.dropdownOptions}
                        inputStyles={
                            selectedValue
                                ? styles.dropdownInputSelected
                                : styles.dropdownInput
                        }
                        disabledItemStyles={styles.disabledDropdown}
                        disabledTextStyles={styles.disabledOptionText}
                        //onDropdownOpen={toggleDropdown}
                        //onDropdownClose={toggleDropdown}
                        setSelected={onSelectOption}
                        defaultOption={defaultOption}
                    />
                ) : (
                    <View style={{ flex: 1, flexDirection: 'row' }}>
                        <View style={{ flex: 1 }}>
                            <CustomCheckBox
                                options={options}
                                defaultValue={defaultOption}
                                onChangeSelected={onSelectOption}
                            />
                        </View>
                        {enableButtonRefresh && (
                            <TouchableOpacity
                                onPress={onRefreshUsers}
                                style={{ marginRight: 20 }}
                            >
                                <Feather
                                    name='refresh-ccw'
                                    size={24}
                                    color={theme.colors.colorPrimary}
                                />
                            </TouchableOpacity>
                        )}
                    </View>
                )}
                {loaderUsersDropdown && <Loader />}
                {/* <View style={styles.dividerHorizontalLine}></View> */}
            </View>
        )
    },
)

interface DropdownMultipleSelectItemI {
    item: FormContentsModel
    hideOrShow: (
        hides?: string[],
        show?: string[],
        data?: FormContentsModel[],
    ) => void
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
}

export const DropdownMultipleSelectItem = React.memo(
    ({
        item,
        hideOrShow,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
    }: DropdownMultipleSelectItemI) => {
        const [selectedOptions, setSelectedOptions] = useState([])
        const { image, loading } = useImageLoader(item.media, PATH_ASSETS)

        useEffect(() => {
            if (item?.old_response) {
                const ids = item.old_response.option_selected_id
                setSelectedOptions(ids)
            }
        }, [item?.old_response])

        const options = item.secondary_actions.map((option) => ({
            key: option._id,
            name: option.label,
        }))

        const onSelectedItemsChange = (key) => {
            setSelectedOptions((prev) => {
                let updated

                if (prev.includes(key)) {
                    updated = prev.filter((k) => k !== key)
                } else {
                    updated = [...prev, key]
                }

                onSelectMultiple(updated)
                return updated
            })
        }
        const onSelectMultiple = async (selectedIds: string[]) => {
            try {
                const selectedActions = item.secondary_actions.filter((a) =>
                    selectedIds.includes(a._id),
                )

                for (const act of selectedActions) {
                    await deleteOldResponse(
                        item._id,
                        act,
                        schedule_id,
                        form_id,
                        store_id,
                    )
                }

                const answer: ModelAnswerFromProps = {
                    _id: item._id,
                    option_selected_text: selectedActions.map((a) => a.label),
                    option_selected_id: selectedActions.map((a) => a._id),
                    question_id: item._id,
                    media: '',
                    question_text: item.title,
                    score: '0', // o ponés suma de scores si querés
                    status: 1,
                    date_finish: new Date().toString(),
                    date_init: new Date().toString(),
                    question_input: '',
                    field_media: '',
                    field_text: '',
                    questionScore: item.questionScore,
                    type: item.input_type.type,
                    ponderar: item.questionScore && item.questionScore > 0,
                    question: item.title,
                    questionOptionSelected: selectedActions.map((a) => a._id),
                    questionOptionSelectedText: selectedActions.map((a) => a.label),
                    questionType: {
                        title: item.input_type.title,
                        type: item.input_type.type,
                        id: item.input_type._id,
                    },
                    questionPrice: '',
                    description: '',
                    tag: '',
                    questionImage: '',
                    questionInput: '',
                }

                await updateFormAnswerSchedule({
                    newAnswer: answer,
                    schedule_id,
                    form_id,
                    store_id,
                })

                checkComplete(answer)
            } catch (err) {
                console.error('Error en onSelectMultiple:', err)
            }
        }

        const deleteOldResponse = async (
            questionId: string,
            selectedOption: SecondaryActionsModel,
            schedule_id: string,
            form_id: string,
            store_id: string,
        ) => {
            try {
                if (
                    selectedOption &&
                    selectedOption.hide_questions &&
                    selectedOption.hide_questions.length > 0
                ) {
                    await ScheduleServices.removeKeyOldResponseFormAnswerSchedule(
                        schedule_id,
                        form_id,
                        store_id,
                        selectedOption.hide_questions,
                    )
                }
            } catch (error) {
                console.error('❌ deleteOldResponse -- ERROR: ', error)
            }
        }

        return (
            <View>
                {item.media && (
                    <>
                        {loading ? (
                            <Loader />
                        ) : (
                            <Image
                                style={styles.image}
                                source={{ uri: image }}
                                onError={(e) => {}}
                            />
                        )}
                    </>
                )}
                <Text style={styles.title}>{item.title}</Text>

                {/* <MultiSelect
                    hideTags
                    items={options}
                    uniqueKey='key'
                    displayKey='name'
                    onSelectedItemsChange={onSelectedItemsChange}
                    selectedItems={selectedOptions}
                    selectText='Selecciona una o más opciones'
                    searchInputPlaceholderText='Buscar...'
                    searchInputStyle={styles.searchInput}
                    onChangeInput={(text) => console.log(text)}
                    fontSize={14}
                    itemFontSize={14}
                    styleTextDropdownSelected={styles.textPlaceholder}
                    itemTextColor={theme.colors.textPrimary}
                    tagRemoveIconColor={theme.colors.colorPrimary}
                    tagBorderColor={theme.colors.lightGray}
                    tagTextColor={theme.colors.textPrimary}
                    selectedItemTextColor={theme.colors.textSecondary}
                    selectedItemIconColor={theme.colors.colorApproved}
                    styleMainWrapper={styles.mainWrapper}
                    styleDropdownMenuSubsection={styles.inputDropdownMenuSubsection}
                    styleItemsContainer={styles.itemsContainer}
                    styleListContainer={styles.listContainer}
                    styleRowList={styles.rowList}
                    styleIndicator={styles.indicator}
                    // styleTextTag={styles.textTag}
                    ref={multiSelectRef}
                    hideSubmitButton={true}
                    hideDropdown={true}
                />
                <View style={styles.marginHorizontal}>
                    {multiSelectRef.current &&
                        multiSelectRef.current.getSelectedItemsExt(selectedOptions)}
                </View> */}

                {options.map((option) => {
                    const isSelected = selectedOptions.includes(option.key)

                    return (
                        <Pressable
                            key={option.key}
                            onPress={() => onSelectedItemsChange(option.key)}
                            style={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                                marginHorizontal: 20,
                                marginVertical: 10,
                            }}
                        >
                            <View
                                style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: 12,
                                    borderWidth: 2,
                                    borderColor: '#999',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {isSelected && (
                                    <View
                                        style={{
                                            width: 12,
                                            height: 12,
                                            borderRadius: 6,
                                            backgroundColor:
                                                theme.colors.colorPrimary,
                                        }}
                                    />
                                )}
                            </View>

                            <Text
                                style={{
                                    fontSize: 15,
                                    color: theme.colors.textPrimary,
                                    flexShrink: 1,
                                }}
                            >
                                {option.name}
                            </Text>
                        </Pressable>
                    )
                })}
            </View>
        )
    },
)
